module.exports = __webpack_public_path__ + "assets/img/1a33-nr.svg";